import styled, { css } from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export const ScCountdown = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  gap: 4px;

  & > div {
    position: relative;
    background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.2)};
    border-radius: 8px;
    padding: 8px;
    min-width: 40px;
    height: 44px;

    .bg {
      display: block;
      position: absolute;
      z-index: 1;
      inset: 0;
      border-radius: 8px;
      padding: 2px;
      -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          112.71deg,
          #ffad01 9.93%,
          #ffe225 46.65%,
          #ffad01 80.43%
        );
      }
    }

    p {
      display: flex;
      flex-direction: column;
      font-size: 10px;
      line-height: 10px;
      text-align: center;

      span {
        font-weight: 700;
        font-size: 18px;
        line-height: 18px;
        letter-spacing: 0.03em;
        text-transform: uppercase;
      }
    }
  }
`;

export enum TimerLabelSize {
  AUTO = 0,
  SMALL = 1,
}
export interface ScTimerLabelProps {
  gray?: boolean;
  size?: TimerLabelSize;
  simpleView?: boolean;
}

export const ScTimerLabel = styled.div<ScTimerLabelProps>`
  display: flex;
  justify-content: center;

  ${({ simpleView, gray, size }) =>
    simpleView
      ? css`
          font-size: 12px;
          line-height: 18px;
          min-width: 72px;
        `
      : css`
          padding: 3px 12px;
          gap: 2px;
          height: 30px;
          width: 138px;
          background: ${({ theme }) =>
            gray ? theme.gray1Color : theme.whiteColor};
          color: ${({ theme }) => theme.blackColor};
          border-radius: 20px;
          font-weight: 700;
          font-size: 16px;
          line-height: 1.5;
          letter-spacing: 0.01em;

          ${
            size === TimerLabelSize.AUTO
              ? css`
                height: 100%;
                width: auto;
                padding: 2px 12px;
              `
              : size === TimerLabelSize.SMALL &&
                css`
                height: 24px;
                width: auto;
                font-size: 12px;
                line-height: 18px;
              `
          }
        `}
`;
